import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { IconError } from '../../assets/IconError';
const Styles = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .input {
        width: calc(100% - calc(var(--border-radius)));
        padding: calc(var(--border-radius) / 2);
        border-radius: calc(var(--border-radius) / 2);
        border: 1px var(--n-grey-10) solid;
        background-color: var(--n-grey-11);
        display: flex;
        gap: 0.6rem;
        .input-text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 0.5rem;
            width: calc(100% - calc(120px + 0.3rem));
            .input-title {
                font-size: 11px;
                font-weight: 600;
            }
            .input-desc {
                font-size: 11px;
                font-weight: 400;
                color: var(--n-grey-7);
            }
        }
    }
    .image {
        flex-grow: 1;
        width: 120px;
        height: 120px;
        box-sizing: content-box;
        background-color: var(--border-2);
        border-radius: calc(var(--border-radius) / 4);
        overflow: hidden;
        position: relative;
        img {
            width: 100%;
            height: 100%;
            position: absolute;
            inset: 0 0 0 0;
            display: block;
        }
    }
    .text-field{
        position: absolute;
        inset: 0 0 0 0;
        padding: 0;
        opacity: 0;
        z-index: 3;
        cursor: pointer;
        outline: none;
        transition: var(--trans-1);
    }
    .error {
        display: flex;
        height: 1rem;
        font-size: var(--fs-small);
        .icon {
            text-align: center;
            width: 1rem;
            height: 1rem;
        }
        .text {
            margin: 0 0.2rem 0 0;
        }
    }
`

    // dokme chesm baray ramz ha

export const ImageInput = ({style, name, error, value, onchange, placeHolder, required, ltr,classname}) => {
    const [image, setImage] = useState('');
    let errorComp = '';
    let classes = 'text-field';

    const fileRef = useRef();
    useEffect(() => {
        fileRef.current.value='';
    }, [value]);

    if(error.toString()){
        classes = 'text-field error-text';
        errorComp = (
            <div className="error">
                <IconError />
                <div className="text">{error}</div>
            </div>
        )
    }
    const changed = (e) => {
        onchange(e);
        // console.log(e.target.files[0]);
        if(e.target.files.length){
            var fr = new FileReader();
            fr.onload = function () {
                setImage(fr.result);
            }
            fr.readAsDataURL(e.target.files[0]);
        } else {
            setImage('');
        }
    }


    if(ltr) {
        classes+= ' ltr-text';
    }
    let imageHolder;
    if(value) {
        imageHolder = <img src={value} alt={'episode'}/>;
    }
    if(image) {
        imageHolder = <img src={image} alt={'episode'}/>;
    }
    return (
        <Styles style={style} className={classname}>
            <div className='input'>
                <div className='image'>
                    {imageHolder}
                </div>
                <div className='input-text'>
                    <div className='input-title'>
                        Upload image
                    </div>
                    <div className='input-desc'>
                        For uploading a image click here or drop the file in this box
                    </div>
                </div>
                
                <input ref={fileRef} className={classes} name={name} type='file' onChange={changed} required={required}/>
            </div>
            {errorComp}
        </Styles>
    )
}